import CartItem2 from './CartItem2.jsx';

export default CartItem2;


// WEBPACK FOOTER //
// ./src/components/CartItem2/index.jsx